/**
 * What a figure may claim about itself (platform design §11.3, §11.5). An
 * estimate is only ever shown with the method version that produced it and its
 * confidence; one that arrives without either is refused, because a bare
 * estimate reads as a measurement.
 */

export interface EstimateFields {
  is_estimate?: boolean;
  estimate_method_version?: string | null;
  estimate_confidence?: number | null;
}

export type Labelling =
  | { kind: 'measured' }
  | { kind: 'estimate'; methodVersion: string; confidence: number }
  | { kind: 'refused' };

export function labellingOf(fields: EstimateFields): Labelling {
  if (fields.is_estimate !== true) return { kind: 'measured' };
  const methodVersion = fields.estimate_method_version ?? null;
  const confidence = fields.estimate_confidence ?? null;
  return methodVersion === null || confidence === null
    ? { kind: 'refused' }
    : { kind: 'estimate', methodVersion, confidence };
}
